import { render, staticRenderFns } from "./OccupantLoadFactor.vue?vue&type=template&id=f0c3afa0&"
import script from "./OccupantLoadFactor.vue?vue&type=script&lang=js&"
export * from "./OccupantLoadFactor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports